import type { StateTagProps } from "./state-tag.type";

import classNames from "classnames";

import { useReferentialState } from "@/entities/referential/referential-state";
import { Tag } from "@/ui/tag";

import "./state-tag.style.less";

export const StateTag = ({ endpoint, value, asText }: StateTagProps) => {
  const { state } = useReferentialState(endpoint, value, "value");

  if (!state) return null;

  return (
    <Tag
      className={classNames("state-tag", { "state-tag-text": asText })}
      data-testid="state-tag"
      variant="solid"
      color={asText ? undefined : state.color}
      style={asText ? { color: state.color } : undefined}
    >
      {state.name}
    </Tag>
  );
};
